import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const Resources: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Resources</h1>
      <p className="section-description">
        Manage various types of resources including books, case studies, and guides with comprehensive content management features.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <DocumentTextIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Resource Management</h3>
              <p className="feature-description">
                Handle resources with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit resources</li>
                <li>Upload and manage resource files</li>
                <li>Set resource visibility (Public, Login Users, Premium)</li>
                <li>Manage resource status (Draft, Published)</li>
                <li>Delete individual resources</li>
                <li>Bulk delete multiple resources</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentTextIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Resource Details</h3>
              <p className="feature-description">
                Comprehensive resource information management:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Resource type selection</li>
                <li>Title and slug management</li>
                <li>Rich text description and content</li>
                <li>Thumbnail image upload</li>
                <li>File upload support (PDF, Word, Excel)</li>
                <li>Type-specific fields (ISBN, Client Name, Steps)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentTextIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Resource List</h3>
              <p className="feature-description">
                View and manage resources in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Thumbnail image</li>
                <li>Title (searchable, sortable)</li>
                <li>Resource type (searchable, sortable)</li>
                <li>Visibility (color-coded badges)</li>
                <li>Status (color-coded badges)</li>
                <li>Creation date (sortable)</li>
                <li>Last update date (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentTextIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Access Control</h3>
              <p className="feature-description">
                Manage resource accessibility:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Public access (green badge)</li>
                <li>Login required (yellow badge)</li>
                <li>Premium access (red badge)</li>
                <li>Filter resources by visibility</li>
                <li>Filter resources by status</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Use clear, descriptive titles and descriptions</li>
            <li>Upload high-quality thumbnail images</li>
            <li>Choose appropriate resource types</li>
            <li>Set correct visibility levels</li>
            <li>Keep resource files up to date</li>
            <li>Regularly review and update content</li>
            <li>Monitor resource usage and access</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Resources; 